"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_boost_1 = __importDefault(require("apollo-boost"));
const StoreStockManagement_1 = __importDefault(require("../ui/StoreStockManagement"));
const storerAssertManagement_1 = __importDefault(require("./storerAssertManagement"));
const mergeConfig = require('coact/config/mergeConfig');
function installClient(fullConfig) {
    const storeAssertManagementPath = '/storeAssertManagement';
    const client = new apollo_boost_1.default({ uri: 'api/route/storeStockManagement' });
    return mergeConfig(fullConfig, {
        routes: {
            storeStockManagement: {
                title: '庫存查詢',
                path: '/storeStockManagement/',
                component: () => StoreStockManagement_1.default({
                    path: '/storeStockManagement',
                    client,
                }),
            },
            storeAssertManagement: {
                title: '庫存盤點',
                path: `${storeAssertManagementPath}/`,
                component: () => storerAssertManagement_1.default({
                    path: storeAssertManagementPath,
                    client,
                }),
            },
        },
    });
}
exports.default = installClient;
